/* tslint:disable:max-line-length */
/**
 * 1
 * Alza API 1
 * Alza Rest Api Swagger Documentation
 *   "path": null
 */

import * as model from '../model'

/** Logged In Vendor User Resource V1 */
export interface LoggedVendorUserRoleV1 {
  /** Team Member Roles */
  teamRoles?: model.TeamMemberRolesV1
  /**
   * Highest Global User Role - In Alza Options: [0 = VendorUser, 1 = VendorAdmin]
   * format: int32
   */
  userRole: UserRoleLoggedVendorUserRoleV1Enum
  /**
   * Highest Team Member Role - In Any Team Options: [1 = TeamAdmin, 10 = TeamManager, 20 = TeamMember]
   * format: int32
   */
  highestTeamRole?: HighestTeamRoleLoggedVendorUserRoleV1Enum
  meta?: model.MetaInfo
}

export enum UserRoleLoggedVendorUserRoleV1Enum {
  VendorUser = 0,
  VendorAdmin = 1,
}

export enum HighestTeamRoleLoggedVendorUserRoleV1Enum {
  TeamAdmin = 1,
  TeamManager = 10,
  TeamMember = 20,
}



// WEBPACK FOOTER //
// ./src/app/api/api/models/logged-vendor-user-role-v1.ts